import {api, entity} from "../../infra/api/rpc/api";
import {BrokerageProjectPossibility, Customer, FullTimePossibility, Gender, WorkIntention,} from "../model/customer";
import {FrontDate} from "../model/frontDate";
import {Occupation} from "../model/project";

/**
 *  GetAllNewestByIDs 系：　仮に存在しないIDを渡されてもエラーにはならずに、存在するデータが戻る
 *  GetAllByIDs系：　存在しないIDが一つでも入っていれば全体として404が戻る
 */
export interface ICustomerRepository {
    getAll(): Promise<Customer[]>;

    getAllByIDs(ids: string[]): Promise<Customer[]>;

    getAllBySearch(
        query: string,
        singleSkillTagIds: string[],
        multiSkillTagIds: string[],
        occupationSkillTagCategory: entity.OccupationSkillTag.Category,
        occupationSkillTagId: string,
        gender: entity.User.Gender,
        age: api.CustomerAgeSearchType,
        workIntention: entity.Customer.WorkIntention,
        fullTimePossibility: entity.Customer.FullTimePossibility,
        page: number,
        limit: number
    ): Promise<Customer[]>;

    get(customerID: string): Promise<Customer>;

    getCountBySearch(
        query: string,
        singleSkillTagIds: string[],
        multiSkillTagIds: string[],
        occupationSkillTagCategory: entity.OccupationSkillTag.Category,
        occupationSkillTagId: string,
        gender: entity.User.Gender,
        age: api.CustomerAgeSearchType,
        workIntention: entity.Customer.WorkIntention,
        fullTimePossibility: entity.Customer.FullTimePossibility
    ): Promise<number | Long>;

    getCountByOccupation(
        customerCountByOccupationRequest: TCustomerCountByOccupationRequest
    ): Promise<number | Long>;

    getForScout(customerID: string): Promise<Customer>;

    create(createCustomerRequest: TCreateCustomerRequest): Promise<Customer>;

    createSuperEngineer(
        createCustomerRequest: TCreateCustomerRequest
    ): Promise<Customer>;

    createPro(createCustomerRequest: TCreateCustomerRequest): Promise<Customer>;

    update(updateCustomerParams: TUpdateCustomerParams): Promise<Customer>;

    updateMultiSkillTag(ids: string[]): Promise<void>;

    generatePDF(): Promise<string>;

    getRecommmendByMatch(id: string): Promise<Customer[]>;

    getRecommmendByTrend(id: string): Promise<Customer[]>;

    generatePR(): Promise<string>;

    generateDutySummary(): Promise<string>;

    // AIエージェントによる自然言語検索
    agenticSearch(query: string): Promise<Customer[]>;
}

export type TCreateCustomerRequest = {
    name: string;
    nameKana: string;
    gender: Gender;
    phoneNumber: string;
    birthdate: FrontDate;
    portfolio: string;
    type: entity.Customer.Type;
    campaign: entity.Customer.Campaign;
    routeInfo: string;
    facebookURL: string;
};

export enum OrderBy {
    OrderBy_CreatedAt_DESC = 0,
    OrderBy_Bookmark_DESC = 1,
}

export type TCustomerCountByOccupationRequest = {
    occupation: Occupation;
};

export type TSearchCustomerRequest = {
    page: number;
    offset: number;
    query: string;
    singleSkillTagIDs: string[];
    multiSkillTagIDs: string[];
    occupationSkillTagCategory: entity.OccupationSkillTag.Category;
    occupationSkillTagId: string;
    gender: entity.User.Gender;
    age: api.CustomerAgeSearchType;
    workIntention: entity.Customer.WorkIntention;
    fullTimePossibility: entity.Customer.FullTimePossibility;
};

export type TUpdateCustomerParams = {
    name: string;
    nameKana: string;
    iconURL: string;
    birthdate: FrontDate;
    gender: number;
    phoneNumber: string;
    pr: string;
    address: string;
    academicBackgrounds: string[];
    requirements: string[];
    languages: number[];
    moreLanguage: string;
    speakingLevel: number;
    resumeURL: string;
    jobHistoryURL: string;
    workingFrequency: number;
    requestedFee: number;
    requestedCondition: string;
    dutySummary: string;
    workIntention: WorkIntention;
    fullTimePossibility: FullTimePossibility;
    brokerageProjectPossibility: BrokerageProjectPossibility;
    portfolio: string;
    birthplace: string;
    facebookURL: string;
    linkedInURL: string;
    xURL: string;
};



// WEBPACK FOOTER //
// ./src/domain/repository/customer_repository.ts